let TipoDocumentoImovelEnum = {
  PROPRIEDADE: {
    id: 1,
    codigo: 'PROPRIEDADE',
    nome: 'Propriedade',
  },
  POSSE: {
    id: 2,
    codigo: 'POSSE',
    nome: 'Posse',
  },
  RLM: {
    id: 3,
    codigo: 'RLM',
    nome: 'Reserva Legal Mínima',
  },
  RPPN: {
    id: 4,
    codigo: 'RPPN',
    nome: 'Reserva Particular do Patrimômio Natural',
  },
  SERVIDAO: {
    id: 5,
    codigo: 'SERVIDAO',
    nome: 'Servidão',
  },
  RL_PROPOSTA: {
    id: 169,
    codigo: 'ARL_PROPOSTA',
    nome: 'Reserva Legal Proposta',
  },
  RL_AVERBADA: {
    id: 170,
    codigo: 'ARL_AVERBADA',
    nome: 'Reserva Legal averbada',
  },
  RL_APROVADA_NAO_AVERBADA: {
    id: 171,
    codigo: 'ARL_APROVADA_NAO_AVERBADA',
    nome: 'Reserva legal aprovada não averbada',
  },
};
  
export default TipoDocumentoImovelEnum;
  